import { Injectable } from '@angular/core';
import { WindowRef } from './window';

@Injectable()
export class LocalStorage {
  constructor(private windowRef: WindowRef) {

  }
  get localStorage(): any {
    let storage = {}
    if (this.windowRef) {
      storage = this.windowRef.nativeWindow.localStorage
    }
    return storage;
  }
}
